import ListDeliveryOrderSuratJalan from './ListDeliveryOrderSuratJalan';

export default ListDeliveryOrderSuratJalan;
